import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { graphql } from "@apollo/client/react/hoc"
import TabbedListingPage from "../Material/TabbedListingPage"
import { HasPermissionsQuery } from "../Functions/querys"
import PriceContainer from "./PricingContainer"
import PromoContainer from "./PromoContainer"
import ReportsPanel from "../Reports/ReportsPanel"

// Neither panel reads currentUser -- both only forward location/navigate down to
// their list header (for URL-driven filter state), and neither self-supplies
// those via a withApolloClient wrap the way most other panels do. Reports needs
// neither -- ReportsPanel owns its own date range, filters and view state.
const pricingPromotionTabs = [
    { id: "#pricing", name: "Pricing", iconClassName: "fa fa-money", permissionRequired: "view_pricingtemplate", render: ({ location, navigate }) => <PriceContainer location={location} navigate={navigate} /> },
    { id: "#promotions", name: "Promotions", iconClassName: "fa fa-tags", permissionRequired: "view_promotiontemplate", render: ({ location, navigate }) => <PromoContainer location={location} navigate={navigate} /> },
    { id: "#reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true, permissionRequired: null, render: () => <ReportsPanel reportId="pricing" /> },
]

const PricingPromotionsPage = (props) => {
    const location = useLocation()
    const navigate = useNavigate()

    return (
        <TabbedListingPage
            className="pricingPromotionsPage"
            tabs={pricingPromotionTabs.map(tab => ({ ...tab, render: () => tab.render({ location, navigate }) }))}
            hasPermissions={props.hasPermissions}
            loading={props.loading}
        />
    )
}

export { pricingPromotionTabs }

export default graphql(HasPermissionsQuery, {
    options: () => ({ variables: { userPermissions: ["view_pricingtemplate", "view_promotiontemplate"] } }),
    props: ({ data: { hasPermissions, loading } }) => ({ hasPermissions, loading }),
})(PricingPromotionsPage)
